/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Timecodes_DescriptionInputs */

const en_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy timecodes from one group to another`)
};

const fr_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier les timecodes d’un groupe à un autre`)
};

const de_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecodes von einer Gruppe in eine andere kopieren`)
};

const it_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia i codici temporali da un gruppo all'altro`)
};

const ru_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирование временных меток из одной группы в другую.`)
};

const es_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar códigos de tiempo de un grupo a otro`)
};

const zh_cn2_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将时间码从一个组复制到另一个组`)
};

const ja_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あるグループから別のグループにタイムコードをコピーする`)
};

const hi_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक समूह से दूसरे समूह में टाइमकोड कॉपी करें`)
};

const pt_pt2_copy_timecodes_description = /** @type {(inputs: Copy_Timecodes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar códigos de tempo de um grupo para outro.`)
};

/**
* | output |
* | --- |
* | "Copy timecodes from one group to another" |
*
* @param {Copy_Timecodes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_timecodes_description = /** @type {((inputs?: Copy_Timecodes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Timecodes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_timecodes_description(inputs)
	if (locale === "de") return de_copy_timecodes_description(inputs)
	if (locale === "it") return it_copy_timecodes_description(inputs)
	if (locale === "ru") return ru_copy_timecodes_description(inputs)
	if (locale === "es") return es_copy_timecodes_description(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_timecodes_description(inputs)
	if (locale === "ja") return ja_copy_timecodes_description(inputs)
	if (locale === "hi") return hi_copy_timecodes_description(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_timecodes_description(inputs)
	return en_copy_timecodes_description(inputs)
});